module.exports = __webpack_public_path__ + "static/media/favicon.92a29457.ico";